import React, {VoidFunctionComponent} from 'react';

import Search from '../search/search';
import Filter from '../filter/filter';
import InfoButton from '../info-button/info-button';

import styles from './map-controls.module.css';

const MapControls: VoidFunctionComponent<Record<string, unknown>> = () => (
  <div className={styles.controls}>
    <Search />
    <Filter />
    <InfoButton />
  </div>
);

export default MapControls;
